module.exports = __webpack_public_path__ + "media/images/Burger Menu Close-b917cd90381ee27d8f6f62e78218eafd.svg";